import React, { useEffect, useState } from 'react';

/**
 * V2 E-Learning image with automatic fallback to legacy URL on 404/error.
 */
const Dv2ElearningImage = ({
    src,
    fallbackSrc,
    alt = '',
    className,
    loading = 'lazy',
    ...rest
}) => {
    const [current, setCurrent] = useState(src);

    useEffect(() => {
        setCurrent(src);
    }, [src]);

    const handleError = () => {
        if (fallbackSrc && current !== fallbackSrc) {
            setCurrent(fallbackSrc);
        }
    };

    if (!current) return null;

    return (
        <img
            src={current}
            alt={alt}
            className={className}
            loading={loading}
            onError={handleError}
            {...rest}
        />
    );
};

export default Dv2ElearningImage;
